//#region src/entityPermissions.ts
const APP_ID = "aimystic";
/** Super admin - grants all permissions everywhere */
const WILDCARD_ALL = "*";
/** App admin - grants all app-level permissions */
const WILDCARD_APP = "app.*";
/** Org admin - grants all org-level permissions */
const WILDCARD_ORG = "org.*";
/** Workspace admin - grants all workspace-level permissions */
const WILDCARD_WORKSPACE = "workspace.*";
/** User admin - grants all user-level permissions (own resources) */
const WILDCARD_USER = "user.*";
/** View the list of all users on the platform */
const APP_USERS_LIST = "app.users.list";
/** View detailed information about any user */
const APP_USERS_READ = "app.users.read";
/** Create new user accounts */
const APP_USERS_CREATE = "app.users.create";
/** Modify any user's account information */
const APP_USERS_UPDATE = "app.users.update";
/** Permanently delete user accounts from the platform */
const APP_USERS_DELETE = "app.users.delete";
/** View the list of all roles defined on the platform */
const APP_ROLES_LIST = "app.roles.list";
/** View detailed information about any role */
const APP_ROLES_READ = "app.roles.read";
/** Create new roles with custom permissions */
const APP_ROLES_CREATE = "app.roles.create";
/** Modify existing roles and their permissions */
const APP_ROLES_UPDATE = "app.roles.update";
/** Delete roles from the platform */
const APP_ROLES_DELETE = "app.roles.delete";
/** Assign roles to users at the platform level */
const APP_ROLES_ASSIGN = "app.roles.assign";
/** View the list of all subscription plans */
const APP_PLANS_LIST = "app.plans.list";
/** View detailed information about any plan */
const APP_PLANS_READ = "app.plans.read";
/** Create new subscription plans */
const APP_PLANS_CREATE = "app.plans.create";
/** Modify existing subscription plans */
const APP_PLANS_UPDATE = "app.plans.update";
/** Delete subscription plans */
const APP_PLANS_DELETE = "app.plans.delete";
/** Assign subscription plans to users */
const APP_PLANS_ASSIGN = "app.plans.assign";
/** Control which plans are visible on the public website */
const APP_PLANS_VISIBILITY = "app.plans.visibility";
/** View the list of all organizations on the platform */
const APP_ORGS_LIST = "app.orgs.list";
/** View detailed information about any organization */
const APP_ORGS_READ = "app.orgs.read";
/** Create new organizations */
const APP_ORGS_CREATE = "app.orgs.create";
/** Modify any organization's settings */
const APP_ORGS_UPDATE = "app.orgs.update";
/** Delete organizations from the platform */
const APP_ORGS_DELETE = "app.orgs.delete";
/** View the list of all AI agents on the platform */
const APP_AGENTS_LIST = "app.agents.list";
/** Modify any AI agent's configuration */
const APP_AGENTS_UPDATE = "app.agents.update";
/** Delete any AI agent from the platform */
const APP_AGENTS_DELETE = "app.agents.delete";
/** Modify any workspace's settings (admin override) */
const APP_WORKSPACES_UPDATE = "app.workspaces.update";
/** View the list of all LLM profiles on the platform */
const APP_LLM_PROFILES_LIST = "app.llm_profiles.list";
/** View detailed information about any LLM profile */
const APP_LLM_PROFILES_READ = "app.llm_profiles.read";
/** Create new LLM profiles */
const APP_LLM_PROFILES_CREATE = "app.llm_profiles.create";
/** Modify existing LLM profiles */
const APP_LLM_PROFILES_UPDATE = "app.llm_profiles.update";
/** Delete LLM profiles */
const APP_LLM_PROFILES_DELETE = "app.llm_profiles.delete";
/** Execute tools using LLM profiles */
const APP_LLM_PROFILES_EXECUTE = "app.llm_profiles.execute";
/** View the list of all transactions and billing records */
const APP_TRANSACTIONS_LIST = "app.transactions.list";
/** View detailed information about any transaction */
const APP_TRANSACTIONS_READ = "app.transactions.read";
/** Create transaction records manually */
const APP_TRANSACTIONS_CREATE = "app.transactions.create";
/** Modify transaction records */
const APP_TRANSACTIONS_UPDATE = "app.transactions.update";
/** Delete transaction records */
const APP_TRANSACTIONS_DELETE = "app.transactions.delete";
/** Create public webpages on the platform */
const APP_WEBPAGES_CREATE = "app.webpages.create";
/** View any webpage content */
const APP_WEBPAGES_READ = "app.webpages.read";
/** Modify any webpage content */
const APP_WEBPAGES_UPDATE = "app.webpages.update";
/** Delete webpages from the platform */
const APP_WEBPAGES_DELETE = "app.webpages.delete";
/** Access the administrative backend interface */
const APP_SYSTEM_BACKEND = "app.system.backend";
/** View the administrative dashboard with platform metrics */
const APP_SYSTEM_DASHBOARD = "app.system.dashboard";
/** View platform logs and debugging information */
const APP_SYSTEM_LOGS = "app.system.logs";
/** Bypass platform limits and quotas */
const APP_SYSTEM_BYPASS_LIMITS = "app.system.bypass_limits";
/** Manage platform-wide integrations and API connections */
const APP_SYSTEM_INTEGRATIONS = "app.system.integrations";
/** List all system wiki pages */
const APP_WIKI_LIST = "app.wiki.list";
/** Read system wiki page content */
const APP_WIKI_READ = "app.wiki.read";
/** Create new system wiki pages */
const APP_WIKI_CREATE = "app.wiki.create";
/** Modify system wiki pages */
const APP_WIKI_UPDATE = "app.wiki.update";
/** Delete system wiki pages */
const APP_WIKI_DELETE = "app.wiki.delete";
/** View organization settings and configuration */
const ORG_SETTINGS_READ = "org.settings.read";
/** Modify organization settings and configuration */
const ORG_SETTINGS_UPDATE = "org.settings.update";
/** View the list of organization members */
const ORG_MEMBERS_LIST = "org.members.list";
/** Invite new members to the organization */
const ORG_MEMBERS_INVITE = "org.members.invite";
/** Remove members from the organization */
const ORG_MEMBERS_REMOVE = "org.members.remove";
/** Assign roles to organization members */
const ORG_MEMBERS_ASSIGN_ROLE = "org.members.assign_role";
/** View organization billing information and invoices */
const ORG_BILLING_READ = "org.billing.read";
/** Modify organization billing settings and payment methods */
const ORG_BILLING_UPDATE = "org.billing.update";
/** View all workspaces in the organization */
const ORG_WORKSPACES_LIST = "org.workspaces.list";
/** Create new workspaces within the organization */
const ORG_WORKSPACES_CREATE = "org.workspaces.create";
/** Delete workspaces from the organization */
const ORG_WORKSPACES_DELETE = "org.workspaces.delete";
/** View all AI agents in the organization */
const ORG_AGENTS_LIST = "org.agents.list";
/** Create AI agents for the organization */
const ORG_AGENTS_CREATE = "org.agents.create";
/** Modify organization AI agents */
const ORG_AGENTS_UPDATE = "org.agents.update";
/** Delete organization AI agents */
const ORG_AGENTS_DELETE = "org.agents.delete";
/** List organization wiki pages */
const ORG_WIKI_LIST = "org.wiki.list";
/** Read organization wiki page content */
const ORG_WIKI_READ = "org.wiki.read";
/** Create organization wiki pages */
const ORG_WIKI_CREATE = "org.wiki.create";
/** Modify organization wiki pages */
const ORG_WIKI_UPDATE = "org.wiki.update";
/** Delete organization wiki pages */
const ORG_WIKI_DELETE = "org.wiki.delete";
/** View workspace settings and configuration */
const WORKSPACE_SETTINGS_READ = "workspace.settings.read";
/** Modify workspace settings such as name, description, and visibility */
const WORKSPACE_SETTINGS_UPDATE = "workspace.settings.update";
/** Delete the workspace entirely */
const WORKSPACE_SETTINGS_DELETE = "workspace.settings.delete";
/** Publish the workspace to make it publicly accessible */
const WORKSPACE_SETTINGS_PUBLISH = "workspace.settings.publish";
/** View the list of workspace members */
const WORKSPACE_MEMBERS_LIST = "workspace.members.list";
/** Invite new members to the workspace */
const WORKSPACE_MEMBERS_INVITE = "workspace.members.invite";
/** Remove members from the workspace */
const WORKSPACE_MEMBERS_KICK = "workspace.members.kick";
/** Permanently ban members from the workspace */
const WORKSPACE_MEMBERS_BAN = "workspace.members.ban";
/** Assign roles to workspace members */
const WORKSPACE_MEMBERS_ASSIGN_ROLE = "workspace.members.assign_role";
/** View AI agents available in the workspace */
const WORKSPACE_AGENTS_LIST = "workspace.agents.list";
/** Add AI agents to the workspace */
const WORKSPACE_AGENTS_ADD = "workspace.agents.add";
/** Remove AI agents from the workspace */
const WORKSPACE_AGENTS_REMOVE = "workspace.agents.remove";
/** Configure AI agent behavior in the workspace */
const WORKSPACE_AGENTS_CONFIGURE = "workspace.agents.configure";
/** Send messages in the workspace */
const WORKSPACE_MESSAGES_SEND = "workspace.messages.send";
/** Delete messages in the workspace */
const WORKSPACE_MESSAGES_DELETE = "workspace.messages.delete";
/** View workspace deployments */
const WORKSPACE_DEPLOYMENTS_READ = "workspace.deployments.read";
/** Create new workspace deployments */
const WORKSPACE_DEPLOYMENTS_CREATE = "workspace.deployments.create";
/** Modify workspace deployments */
const WORKSPACE_DEPLOYMENTS_UPDATE = "workspace.deployments.update";
/** Delete workspace deployments */
const WORKSPACE_DEPLOYMENTS_DELETE = "workspace.deployments.delete";
/** Feature gate: Access to agents feature */
const USER_AGENTS_LIST = "user.agents.list";
/** Feature gate: Can create new agents */
const USER_AGENTS_CREATE = "user.agents.create";
/** Feature gate: Can trigger tool execution on agents */
const USER_AGENTS_EXECUTE = "user.agents.execute";
/** Feature gate: Access to workspaces feature */
const USER_WORKSPACES_LIST = "user.workspaces.list";
/** Feature gate: Can create new workspaces */
const USER_WORKSPACES_CREATE = "user.workspaces.create";
/** Feature gate: Can publish workspaces to community */
const USER_WORKSPACES_PUBLISH = "user.workspaces.publish";
/** Feature gate: Access to the Tasks nav panel and task management */
const USER_TASKS_MANAGE = "user.tasks.manage";
/** Feature gate: Cross-workspace task dependencies */
const USER_TASKS_CROSS_WORKSPACE_DEPS = "user.tasks.cross_workspace_deps";
/** View your own LLM profiles */
const USER_LLM_PROFILE_READ = "user.llm_profile.read";
/** Create personal LLM profiles */
const USER_LLM_PROFILE_CREATE = "user.llm_profile.create";
/** Modify your own LLM profiles */
const USER_LLM_PROFILE_UPDATE = "user.llm_profile.update";
/** Delete your own LLM profiles */
const USER_LLM_PROFILE_DELETE = "user.llm_profile.delete";
/** Execute queries using LLM profiles */
const USER_LLM_PROFILE_EXECUTE = "user.llm_profile.execute";
/** Manage your personal integrations and API connections */
const USER_INTEGRATIONS_MANAGE = "user.integrations.manage";
/** Access the Bloomstack application */
const USER_ACCESS_APP = "user.access.app";
/** Access deployed workspaces (mini apps) */
const USER_ACCESS_DEPLOYMENTS = "user.access.deployments";
const APP_PERMISSION_GROUPS = [
	{
		id: "app.users",
		name: "User Management",
		description: "Manage platform users, their accounts and access",
		scope: "app",
		permissions: [
			{
				key: APP_USERS_LIST,
				name: "List Users",
				description: "View the list of all users on the platform",
				scope: "app",
				category: "users"
			},
			{
				key: APP_USERS_READ,
				name: "Read Users",
				description: "View detailed information about any user",
				scope: "app",
				category: "users"
			},
			{
				key: APP_USERS_CREATE,
				name: "Create Users",
				description: "Create new user accounts",
				scope: "app",
				category: "users"
			},
			{
				key: APP_USERS_UPDATE,
				name: "Update Users",
				description: "Modify any user's account information",
				scope: "app",
				category: "users"
			},
			{
				key: APP_USERS_DELETE,
				name: "Delete Users",
				description: "Permanently delete user accounts from the platform",
				scope: "app",
				category: "users"
			}
		]
	},
	{
		id: "app.roles",
		name: "Role Management",
		description: "Manage roles and their associated permissions",
		scope: "app",
		permissions: [
			{
				key: APP_ROLES_LIST,
				name: "List Roles",
				description: "View the list of all roles defined on the platform",
				scope: "app",
				category: "roles"
			},
			{
				key: APP_ROLES_READ,
				name: "Read Roles",
				description: "View detailed information about any role",
				scope: "app",
				category: "roles"
			},
			{
				key: APP_ROLES_CREATE,
				name: "Create Roles",
				description: "Create new roles with custom permissions",
				scope: "app",
				category: "roles"
			},
			{
				key: APP_ROLES_UPDATE,
				name: "Update Roles",
				description: "Modify existing roles and their permissions",
				scope: "app",
				category: "roles"
			},
			{
				key: APP_ROLES_DELETE,
				name: "Delete Roles",
				description: "Delete roles from the platform",
				scope: "app",
				category: "roles"
			},
			{
				key: APP_ROLES_ASSIGN,
				name: "Assign Roles",
				description: "Assign roles to users at the platform level",
				scope: "app",
				category: "roles"
			}
		]
	},
	{
		id: "app.plans",
		name: "Subscription Plans",
		description: "Manage subscription plans and user assignments",
		scope: "app",
		permissions: [
			{
				key: APP_PLANS_LIST,
				name: "List Plans",
				description: "View the list of all subscription plans",
				scope: "app",
				category: "plans"
			},
			{
				key: APP_PLANS_READ,
				name: "Read Plans",
				description: "View detailed information about any plan",
				scope: "app",
				category: "plans"
			},
			{
				key: APP_PLANS_CREATE,
				name: "Create Plans",
				description: "Create new subscription plans",
				scope: "app",
				category: "plans"
			},
			{
				key: APP_PLANS_UPDATE,
				name: "Update Plans",
				description: "Modify existing subscription plans",
				scope: "app",
				category: "plans"
			},
			{
				key: APP_PLANS_DELETE,
				name: "Delete Plans",
				description: "Delete subscription plans",
				scope: "app",
				category: "plans"
			},
			{
				key: APP_PLANS_ASSIGN,
				name: "Assign Plans",
				description: "Assign subscription plans to users",
				scope: "app",
				category: "plans"
			},
			{
				key: APP_PLANS_VISIBILITY,
				name: "Plan Visibility",
				description: "Control which plans are visible on the public website",
				scope: "app",
				category: "plans"
			}
		]
	},
	{
		id: "app.orgs",
		name: "Organization Management",
		description: "Manage all organizations on the platform",
		scope: "app",
		permissions: [
			{
				key: APP_ORGS_LIST,
				name: "List Organizations",
				description: "View the list of all organizations on the platform",
				scope: "app",
				category: "orgs"
			},
			{
				key: APP_ORGS_READ,
				name: "Read Organizations",
				description: "View detailed information about any organization",
				scope: "app",
				category: "orgs"
			},
			{
				key: APP_ORGS_CREATE,
				name: "Create Organizations",
				description: "Create new organizations",
				scope: "app",
				category: "orgs"
			},
			{
				key: APP_ORGS_UPDATE,
				name: "Update Organizations",
				description: "Modify any organization's settings",
				scope: "app",
				category: "orgs"
			},
			{
				key: APP_ORGS_DELETE,
				name: "Delete Organizations",
				description: "Delete organizations from the platform",
				scope: "app",
				category: "orgs"
			}
		]
	},
	{
		id: "app.agents",
		name: "Agent Management (Admin)",
		description: "Administrative control over all AI agents on the platform",
		scope: "app",
		permissions: [
			{
				key: APP_AGENTS_LIST,
				name: "List All Agents",
				description: "View the list of all AI agents on the platform",
				scope: "app",
				category: "agents"
			},
			{
				key: APP_AGENTS_UPDATE,
				name: "Edit All Agents",
				description: "Modify any AI agent's configuration",
				scope: "app",
				category: "agents"
			},
			{
				key: APP_AGENTS_DELETE,
				name: "Delete All Agents",
				description: "Delete any AI agent from the platform",
				scope: "app",
				category: "agents"
			}
		]
	},
	{
		id: "app.workspaces",
		name: "Workspace Management (Admin)",
		description: "Administrative control over all workspaces",
		scope: "app",
		permissions: [{
			key: APP_WORKSPACES_UPDATE,
			name: "Edit All Workspaces",
			description: "Modify any workspace's settings (admin override)",
			scope: "app",
			category: "workspaces"
		}]
	},
	{
		id: "app.llm_profiles",
		name: "LLM Profiles",
		description: "Manage platform-wide LLM configurations",
		scope: "app",
		permissions: [
			{
				key: APP_LLM_PROFILES_LIST,
				name: "List LLM Profiles",
				description: "View the list of all LLM profiles on the platform",
				scope: "app",
				category: "llm_profiles"
			},
			{
				key: APP_LLM_PROFILES_READ,
				name: "Read LLM Profiles",
				description: "View detailed information about any LLM profile",
				scope: "app",
				category: "llm_profiles"
			},
			{
				key: APP_LLM_PROFILES_CREATE,
				name: "Create LLM Profiles",
				description: "Create new LLM profiles",
				scope: "app",
				category: "llm_profiles"
			},
			{
				key: APP_LLM_PROFILES_UPDATE,
				name: "Update LLM Profiles",
				description: "Modify existing LLM profiles",
				scope: "app",
				category: "llm_profiles"
			},
			{
				key: APP_LLM_PROFILES_DELETE,
				name: "Delete LLM Profiles",
				description: "Delete LLM profiles",
				scope: "app",
				category: "llm_profiles"
			},
			{
				key: APP_LLM_PROFILES_EXECUTE,
				name: "Execute LLM Profiles",
				description: "Execute tools using LLM profiles",
				scope: "app",
				category: "llm_profiles"
			}
		]
	},
	{
		id: "app.transactions",
		name: "Transactions & Billing",
		description: "View and manage platform billing records",
		scope: "app",
		permissions: [
			{
				key: APP_TRANSACTIONS_LIST,
				name: "List Transactions",
				description: "View the list of all transactions and billing records",
				scope: "app",
				category: "transactions"
			},
			{
				key: APP_TRANSACTIONS_READ,
				name: "Read Transactions",
				description: "View detailed information about any transaction",
				scope: "app",
				category: "transactions"
			},
			{
				key: APP_TRANSACTIONS_CREATE,
				name: "Create Transactions",
				description: "Create transaction records manually",
				scope: "app",
				category: "transactions"
			},
			{
				key: APP_TRANSACTIONS_UPDATE,
				name: "Update Transactions",
				description: "Modify transaction records",
				scope: "app",
				category: "transactions"
			},
			{
				key: APP_TRANSACTIONS_DELETE,
				name: "Delete Transactions",
				description: "Delete transaction records",
				scope: "app",
				category: "transactions"
			}
		]
	},
	{
		id: "app.webpages",
		name: "Webpage Management",
		description: "Manage public webpages",
		scope: "app",
		permissions: [
			{
				key: APP_WEBPAGES_CREATE,
				name: "Create Webpages",
				description: "Create public webpages on the platform",
				scope: "app",
				category: "webpages"
			},
			{
				key: APP_WEBPAGES_READ,
				name: "Read Webpages",
				description: "View any webpage content",
				scope: "app",
				category: "webpages"
			},
			{
				key: APP_WEBPAGES_UPDATE,
				name: "Update Webpages",
				description: "Modify any webpage content",
				scope: "app",
				category: "webpages"
			},
			{
				key: APP_WEBPAGES_DELETE,
				name: "Delete Webpages",
				description: "Delete webpages from the platform",
				scope: "app",
				category: "webpages"
			}
		]
	},
	{
		id: "app.system",
		name: "System Administration",
		description: "Platform-wide system settings and access",
		scope: "app",
		permissions: [
			{
				key: APP_SYSTEM_BACKEND,
				name: "Backend Access",
				description: "Access the administrative backend interface",
				scope: "app",
				category: "system"
			},
			{
				key: APP_SYSTEM_DASHBOARD,
				name: "Dashboard Access",
				description: "View the administrative dashboard with platform metrics",
				scope: "app",
				category: "system"
			},
			{
				key: APP_SYSTEM_LOGS,
				name: "View Logs",
				description: "View platform logs and debugging information",
				scope: "app",
				category: "system"
			},
			{
				key: APP_SYSTEM_BYPASS_LIMITS,
				name: "Bypass Limits",
				description: "Bypass platform limits and quotas",
				scope: "app",
				category: "system"
			},
			{
				key: APP_SYSTEM_INTEGRATIONS,
				name: "Manage Integrations",
				description: "Manage platform-wide integrations and API connections",
				scope: "app",
				category: "system"
			}
		]
	},
	{
		id: "app.wiki",
		name: "Wiki",
		description: "Manage system-wide wiki pages (skills, knowledge, documentation)",
		scope: "app",
		permissions: [
			{
				key: APP_WIKI_LIST,
				name: "List Wiki Pages",
				description: "View the list of system wiki pages",
				scope: "app",
				category: "wiki"
			},
			{
				key: APP_WIKI_READ,
				name: "Read Wiki Pages",
				description: "Read system wiki page content",
				scope: "app",
				category: "wiki"
			},
			{
				key: APP_WIKI_CREATE,
				name: "Create Wiki Pages",
				description: "Create new system wiki pages",
				scope: "app",
				category: "wiki"
			},
			{
				key: APP_WIKI_UPDATE,
				name: "Update Wiki Pages",
				description: "Edit system wiki pages",
				scope: "app",
				category: "wiki"
			},
			{
				key: APP_WIKI_DELETE,
				name: "Delete Wiki Pages",
				description: "Delete system wiki pages",
				scope: "app",
				category: "wiki"
			}
		]
	}
];
const ORG_PERMISSION_GROUPS = [
	{
		id: "org.settings",
		name: "Organization Settings",
		description: "Manage organization configuration",
		scope: "org",
		permissions: [{
			key: ORG_SETTINGS_READ,
			name: "View Settings",
			description: "View organization settings and configuration",
			scope: "org",
			category: "settings"
		}, {
			key: ORG_SETTINGS_UPDATE,
			name: "Edit Settings",
			description: "Modify organization settings and configuration",
			scope: "org",
			category: "settings"
		}]
	},
	{
		id: "org.members",
		name: "Member Management",
		description: "Manage organization members and their roles",
		scope: "org",
		permissions: [
			{
				key: ORG_MEMBERS_LIST,
				name: "List Members",
				description: "View the list of organization members",
				scope: "org",
				category: "members"
			},
			{
				key: ORG_MEMBERS_INVITE,
				name: "Invite Members",
				description: "Invite new members to the organization",
				scope: "org",
				category: "members"
			},
			{
				key: ORG_MEMBERS_REMOVE,
				name: "Remove Members",
				description: "Remove members from the organization",
				scope: "org",
				category: "members"
			},
			{
				key: ORG_MEMBERS_ASSIGN_ROLE,
				name: "Assign Roles",
				description: "Assign roles to organization members",
				scope: "org",
				category: "members"
			}
		]
	},
	{
		id: "org.billing",
		name: "Billing",
		description: "Manage organization billing and payments",
		scope: "org",
		permissions: [{
			key: ORG_BILLING_READ,
			name: "View Billing",
			description: "View organization billing information and invoices",
			scope: "org",
			category: "billing"
		}, {
			key: ORG_BILLING_UPDATE,
			name: "Edit Billing",
			description: "Modify organization billing settings and payment methods",
			scope: "org",
			category: "billing"
		}]
	},
	{
		id: "org.workspaces",
		name: "Workspaces",
		description: "Manage organization workspaces",
		scope: "org",
		permissions: [
			{
				key: ORG_WORKSPACES_LIST,
				name: "List Workspaces",
				description: "View all workspaces in the organization",
				scope: "org",
				category: "workspaces"
			},
			{
				key: ORG_WORKSPACES_CREATE,
				name: "Create Workspaces",
				description: "Create new workspaces within the organization",
				scope: "org",
				category: "workspaces"
			},
			{
				key: ORG_WORKSPACES_DELETE,
				name: "Delete Workspaces",
				description: "Delete workspaces from the organization",
				scope: "org",
				category: "workspaces"
			}
		]
	},
	{
		id: "org.agents",
		name: "AI Agents",
		description: "Manage organization AI agents",
		scope: "org",
		permissions: [
			{
				key: ORG_AGENTS_LIST,
				name: "List Agents",
				description: "View all AI agents in the organization",
				scope: "org",
				category: "agents"
			},
			{
				key: ORG_AGENTS_CREATE,
				name: "Create Agents",
				description: "Create AI agents for the organization",
				scope: "org",
				category: "agents"
			},
			{
				key: ORG_AGENTS_UPDATE,
				name: "Edit Agents",
				description: "Modify organization AI agents",
				scope: "org",
				category: "agents"
			},
			{
				key: ORG_AGENTS_DELETE,
				name: "Delete Agents",
				description: "Delete organization AI agents",
				scope: "org",
				category: "agents"
			}
		]
	}
];
const WORKSPACE_PERMISSION_GROUPS = [
	{
		id: "workspace.settings",
		name: "Workspace Settings",
		description: "Manage workspace configuration",
		scope: "workspace",
		permissions: [
			{
				key: WORKSPACE_SETTINGS_READ,
				name: "View Settings",
				description: "View workspace settings and configuration",
				scope: "workspace",
				category: "settings"
			},
			{
				key: WORKSPACE_SETTINGS_UPDATE,
				name: "Edit Settings",
				description: "Modify workspace settings such as name, description, and visibility",
				scope: "workspace",
				category: "settings"
			},
			{
				key: WORKSPACE_SETTINGS_DELETE,
				name: "Delete Workspace",
				description: "Delete the workspace entirely",
				scope: "workspace",
				category: "settings"
			},
			{
				key: WORKSPACE_SETTINGS_PUBLISH,
				name: "Publish Workspace",
				description: "Publish the workspace to make it publicly accessible",
				scope: "workspace",
				category: "settings"
			}
		]
	},
	{
		id: "workspace.members",
		name: "Member Management",
		description: "Manage workspace members",
		scope: "workspace",
		permissions: [
			{
				key: WORKSPACE_MEMBERS_LIST,
				name: "List Members",
				description: "View the list of workspace members",
				scope: "workspace",
				category: "members"
			},
			{
				key: WORKSPACE_MEMBERS_INVITE,
				name: "Invite Members",
				description: "Invite new members to the workspace",
				scope: "workspace",
				category: "members"
			},
			{
				key: WORKSPACE_MEMBERS_KICK,
				name: "Kick Members",
				description: "Remove members from the workspace",
				scope: "workspace",
				category: "members"
			},
			{
				key: WORKSPACE_MEMBERS_BAN,
				name: "Ban Members",
				description: "Permanently ban members from the workspace",
				scope: "workspace",
				category: "members"
			},
			{
				key: WORKSPACE_MEMBERS_ASSIGN_ROLE,
				name: "Assign Roles",
				description: "Assign roles to workspace members",
				scope: "workspace",
				category: "members"
			}
		]
	},
	{
		id: "workspace.agents",
		name: "AI Agents",
		description: "Manage AI agents in the workspace",
		scope: "workspace",
		permissions: [
			{
				key: WORKSPACE_AGENTS_LIST,
				name: "List Agents",
				description: "View AI agents available in the workspace",
				scope: "workspace",
				category: "agents"
			},
			{
				key: WORKSPACE_AGENTS_ADD,
				name: "Add Agents",
				description: "Add AI agents to the workspace",
				scope: "workspace",
				category: "agents"
			},
			{
				key: WORKSPACE_AGENTS_REMOVE,
				name: "Remove Agents",
				description: "Remove AI agents from the workspace",
				scope: "workspace",
				category: "agents"
			},
			{
				key: WORKSPACE_AGENTS_CONFIGURE,
				name: "Configure Agents",
				description: "Configure AI agent behavior in the workspace",
				scope: "workspace",
				category: "agents"
			}
		]
	},
	{
		id: "workspace.messages",
		name: "Messages",
		description: "Message permissions in the workspace",
		scope: "workspace",
		permissions: [{
			key: WORKSPACE_MESSAGES_SEND,
			name: "Send Messages",
			description: "Send messages in the workspace",
			scope: "workspace",
			category: "messages"
		}, {
			key: WORKSPACE_MESSAGES_DELETE,
			name: "Delete Messages",
			description: "Delete messages in the workspace",
			scope: "workspace",
			category: "messages"
		}]
	},
	{
		id: "workspace.deployments",
		name: "Deployments",
		description: "Manage workspace deployments",
		scope: "workspace",
		permissions: [
			{
				key: WORKSPACE_DEPLOYMENTS_READ,
				name: "View Deployments",
				description: "View workspace deployments",
				scope: "workspace",
				category: "deployments"
			},
			{
				key: WORKSPACE_DEPLOYMENTS_CREATE,
				name: "Create Deployments",
				description: "Create new workspace deployments",
				scope: "workspace",
				category: "deployments"
			},
			{
				key: WORKSPACE_DEPLOYMENTS_UPDATE,
				name: "Edit Deployments",
				description: "Modify workspace deployments",
				scope: "workspace",
				category: "deployments"
			},
			{
				key: WORKSPACE_DEPLOYMENTS_DELETE,
				name: "Delete Deployments",
				description: "Delete workspace deployments",
				scope: "workspace",
				category: "deployments"
			}
		]
	}
];
const USER_PERMISSION_GROUPS = [
	{
		id: "user.agents",
		name: "Agents",
		description: "Feature gates for AI agents",
		scope: "user",
		permissions: [
			{
				key: USER_AGENTS_LIST,
				name: "Access Agents",
				description: "Access to agents feature (view, edit, delete your own)",
				scope: "user",
				category: "agents"
			},
			{
				key: USER_AGENTS_CREATE,
				name: "Create Agents",
				description: "Create new AI agents",
				scope: "user",
				category: "agents"
			},
			{
				key: USER_AGENTS_EXECUTE,
				name: "Execute Tools",
				description: "Trigger tool execution on AI agents",
				scope: "user",
				category: "agents"
			}
		]
	},
	{
		id: "user.workspaces",
		name: "Workspaces",
		description: "Feature gates for workspaces",
		scope: "user",
		permissions: [
			{
				key: USER_WORKSPACES_LIST,
				name: "Access Workspaces",
				description: "Access to workspaces feature (view, edit, delete your own)",
				scope: "user",
				category: "workspaces"
			},
			{
				key: USER_WORKSPACES_CREATE,
				name: "Create Workspaces",
				description: "Create new workspaces",
				scope: "user",
				category: "workspaces"
			},
			{
				key: USER_WORKSPACES_PUBLISH,
				name: "Publish Workspaces",
				description: "Publish workspaces to community",
				scope: "user",
				category: "workspaces"
			}
		]
	},
	{
		id: "user.tasks",
		name: "Tasks",
		description: "Feature gates for task management",
		scope: "user",
		permissions: [{
			key: USER_TASKS_MANAGE,
			name: "Manage Tasks",
			description: "Access the Tasks nav panel and task management",
			scope: "user",
			category: "tasks"
		}, {
			key: USER_TASKS_CROSS_WORKSPACE_DEPS,
			name: "Cross-Workspace Task Dependencies",
			description: "Create task dependencies across workspaces",
			scope: "user",
			category: "tasks"
		}]
	},
	{
		id: "user.llm_profile",
		name: "LLM Profiles",
		description: "Manage your personal LLM configurations",
		scope: "user",
		permissions: [
			{
				key: USER_LLM_PROFILE_READ,
				name: "Read Profiles",
				description: "View your own LLM profiles",
				scope: "user",
				category: "llm_profile"
			},
			{
				key: USER_LLM_PROFILE_CREATE,
				name: "Create Profiles",
				description: "Create personal LLM profiles",
				scope: "user",
				category: "llm_profile"
			},
			{
				key: USER_LLM_PROFILE_UPDATE,
				name: "Edit Profiles",
				description: "Modify your own LLM profiles",
				scope: "user",
				category: "llm_profile"
			},
			{
				key: USER_LLM_PROFILE_DELETE,
				name: "Delete Profiles",
				description: "Delete your own LLM profiles",
				scope: "user",
				category: "llm_profile"
			},
			{
				key: USER_LLM_PROFILE_EXECUTE,
				name: "Execute Queries",
				description: "Execute queries using LLM profiles",
				scope: "user",
				category: "llm_profile"
			}
		]
	},
	{
		id: "user.integrations",
		name: "Integrations",
		description: "Manage your personal integrations",
		scope: "user",
		permissions: [{
			key: USER_INTEGRATIONS_MANAGE,
			name: "Manage Integrations",
			description: "Manage your personal integrations and API connections",
			scope: "user",
			category: "integrations"
		}]
	},
	{
		id: "user.access",
		name: "Access",
		description: "Application access permissions",
		scope: "user",
		permissions: [{
			key: USER_ACCESS_APP,
			name: "App Access",
			description: "Access the Bloomstack application",
			scope: "user",
			category: "access"
		}, {
			key: USER_ACCESS_DEPLOYMENTS,
			name: "Deployment Access",
			description: "Access deployed workspaces and mini apps",
			scope: "user",
			category: "access"
		}]
	}
];
const ALL_PERMISSION_GROUPS = [
	...APP_PERMISSION_GROUPS,
	...ORG_PERMISSION_GROUPS,
	...WORKSPACE_PERMISSION_GROUPS,
	...USER_PERMISSION_GROUPS
];
function getAllPermissions() {
	return ALL_PERMISSION_GROUPS.flatMap((group) => group.permissions.map((p) => p.key));
}
function getPermissionsByScope(scope) {
	return ALL_PERMISSION_GROUPS.filter((group) => group.scope === scope).flatMap((group) => group.permissions.map((p) => p.key));
}

//#endregion
export { ALL_PERMISSION_GROUPS, APP_AGENTS_DELETE, APP_AGENTS_LIST, APP_AGENTS_UPDATE, APP_ID, APP_LLM_PROFILES_CREATE, APP_LLM_PROFILES_DELETE, APP_LLM_PROFILES_EXECUTE, APP_LLM_PROFILES_LIST, APP_LLM_PROFILES_READ, APP_LLM_PROFILES_UPDATE, APP_ORGS_CREATE, APP_ORGS_DELETE, APP_ORGS_LIST, APP_ORGS_READ, APP_ORGS_UPDATE, APP_PERMISSION_GROUPS, APP_PLANS_ASSIGN, APP_PLANS_CREATE, APP_PLANS_DELETE, APP_PLANS_LIST, APP_PLANS_READ, APP_PLANS_UPDATE, APP_PLANS_VISIBILITY, APP_ROLES_ASSIGN, APP_ROLES_CREATE, APP_ROLES_DELETE, APP_ROLES_LIST, APP_ROLES_READ, APP_ROLES_UPDATE, APP_SYSTEM_BACKEND, APP_SYSTEM_BYPASS_LIMITS, APP_SYSTEM_DASHBOARD, APP_SYSTEM_INTEGRATIONS, APP_SYSTEM_LOGS, APP_TRANSACTIONS_CREATE, APP_TRANSACTIONS_DELETE, APP_TRANSACTIONS_LIST, APP_TRANSACTIONS_READ, APP_TRANSACTIONS_UPDATE, APP_USERS_CREATE, APP_USERS_DELETE, APP_USERS_LIST, APP_USERS_READ, APP_USERS_UPDATE, APP_WEBPAGES_CREATE, APP_WEBPAGES_DELETE, APP_WEBPAGES_READ, APP_WEBPAGES_UPDATE, APP_WIKI_CREATE, APP_WIKI_DELETE, APP_WIKI_LIST, APP_WIKI_READ, APP_WIKI_UPDATE, APP_WORKSPACES_UPDATE, ORG_AGENTS_CREATE, ORG_AGENTS_DELETE, ORG_AGENTS_LIST, ORG_AGENTS_UPDATE, ORG_BILLING_READ, ORG_BILLING_UPDATE, ORG_MEMBERS_ASSIGN_ROLE, ORG_MEMBERS_INVITE, ORG_MEMBERS_LIST, ORG_MEMBERS_REMOVE, ORG_PERMISSION_GROUPS, ORG_SETTINGS_READ, ORG_SETTINGS_UPDATE, ORG_WIKI_CREATE, ORG_WIKI_DELETE, ORG_WIKI_LIST, ORG_WIKI_READ, ORG_WIKI_UPDATE, ORG_WORKSPACES_CREATE, ORG_WORKSPACES_DELETE, ORG_WORKSPACES_LIST, USER_ACCESS_APP, USER_ACCESS_DEPLOYMENTS, USER_AGENTS_CREATE, USER_AGENTS_EXECUTE, USER_AGENTS_LIST, USER_INTEGRATIONS_MANAGE, USER_LLM_PROFILE_CREATE, USER_LLM_PROFILE_DELETE, USER_LLM_PROFILE_EXECUTE, USER_LLM_PROFILE_READ, USER_LLM_PROFILE_UPDATE, USER_PERMISSION_GROUPS, USER_TASKS_CROSS_WORKSPACE_DEPS, USER_TASKS_MANAGE, USER_WORKSPACES_CREATE, USER_WORKSPACES_LIST, USER_WORKSPACES_PUBLISH, WILDCARD_ALL, WILDCARD_APP, WILDCARD_ORG, WILDCARD_USER, WILDCARD_WORKSPACE, WORKSPACE_AGENTS_ADD, WORKSPACE_AGENTS_CONFIGURE, WORKSPACE_AGENTS_LIST, WORKSPACE_AGENTS_REMOVE, WORKSPACE_DEPLOYMENTS_CREATE, WORKSPACE_DEPLOYMENTS_DELETE, WORKSPACE_DEPLOYMENTS_READ, WORKSPACE_DEPLOYMENTS_UPDATE, WORKSPACE_MEMBERS_ASSIGN_ROLE, WORKSPACE_MEMBERS_BAN, WORKSPACE_MEMBERS_INVITE, WORKSPACE_MEMBERS_KICK, WORKSPACE_MEMBERS_LIST, WORKSPACE_MESSAGES_DELETE, WORKSPACE_MESSAGES_SEND, WORKSPACE_PERMISSION_GROUPS, WORKSPACE_SETTINGS_DELETE, WORKSPACE_SETTINGS_PUBLISH, WORKSPACE_SETTINGS_READ, WORKSPACE_SETTINGS_UPDATE, getAllPermissions, getPermissionsByScope };
//# sourceMappingURL=entityPermissions.js.map